var map = {
	"./consult/module.js": "./src/modules/consult/module.js",
	"./examInfo/module.js": "./src/modules/examInfo/module.js",
	"./layout/module.js": "./src/modules/layout/module.js",
	"./login/module.js": "./src/modules/login/module.js",
	"./main/module.js": "./src/modules/main/module.js",
	"./personalCenter/module.js": "./src/modules/personalCenter/module.js",
	"./printNTS/module.js": "./src/modules/printNTS/module.js",
	"./register/module.js": "./src/modules/register/module.js",
	"./registrationQuery/module.js": "./src/modules/registrationQuery/module.js",
	"./resultsInquiry/module.js": "./src/modules/resultsInquiry/module.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/modules sync recursive module.js$";